import { useTranslation } from 'react-i18next'

/**
 * W7 Q10: a new read (one with `plot_inputs`) whose cut plots did not load, were
 * refused or cannot be drawn says so, with a retry. It never falls back to the
 * browser's cut bands: every figure on a new read is Python's.
 */

export interface CutPlotsErrorProps {
  onRetry?: () => void
  testIdPrefix?: string
}

export function CutPlotsError(props: CutPlotsErrorProps) {
  const { onRetry, testIdPrefix = 'qs-cut-plots-error' } = props

  const { t } = useTranslation('app')

  return (
    <div
      role="alert"
      className="flex flex-wrap items-center justify-between gap-2 rounded-md border border-twin-chat-divider bg-twin-chat-bubble/20 px-3 py-2 text-xs text-twin-chat-fg-muted"
      data-testid={testIdPrefix}
    >
      <span>{t('studyReport.cutPlotsFailed')}</span>
      {onRetry ? (
        <button
          type="button"
          onClick={onRetry}
          className="rounded-md border border-border px-2 py-0.5 text-xs text-twin-chat-fg hover:bg-muted"
          data-testid={`${testIdPrefix}-retry`}
        >
          {t('studyReport.cutPlotsRetry')}
        </button>
      ) : null}
    </div>
  )
}
